import { IStripeSubscriptionPrice } from '@interfaces/fc-payment/subscriptions';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IsubscriptionSlice {
    planPrice:IStripeSubscriptionPrice | null
}
export const subscriptionSlice = createSlice({
    name: 'plan-price',
    initialState: {
        planPrice: null,
    } as IsubscriptionSlice ,
    reducers: {
        setPlanPrice: (state, action: PayloadAction<IStripeSubscriptionPrice | null >) => {
            state.planPrice = action.payload;
        },
        cleanSubscriptionSlice: (state) => {
            state.planPrice = null
        },
    },
});

export const { setPlanPrice, cleanSubscriptionSlice } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
